import { getEligibleAddOnSkuIds } from 'pricing-pages-lib/utils/restrictionUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const eligibleAddOnSkuIdsSelector = createSelectorFromUtil(getEligibleAddOnSkuIds, transformState);